import type { CartAction, CartState } from './types'

export const initialCartState: CartState = { lines: [] }

export function cartReducer(state: CartState, action: CartAction): CartState {
  switch (action.type) {
    case 'ADD_ITEM': {
      const quantity = action.quantity ?? 1
      const existing = state.lines.find((line) => line.menuItemId === action.item.menuItemId)
      if (existing) {
        return {
          lines: state.lines.map((line) =>
            line.menuItemId === action.item.menuItemId
              ? { ...line, quantity: line.quantity + quantity }
              : line,
          ),
        }
      }
      return { lines: [...state.lines, { ...action.item, quantity }] }
    }
    case 'SET_QUANTITY': {
      if (action.quantity <= 0) {
        return { lines: state.lines.filter((line) => line.menuItemId !== action.menuItemId) }
      }
      return {
        lines: state.lines.map((line) =>
          line.menuItemId === action.menuItemId ? { ...line, quantity: action.quantity } : line,
        ),
      }
    }
    case 'REMOVE_ITEM':
      return { lines: state.lines.filter((line) => line.menuItemId !== action.menuItemId) }
    case 'CLEAR':
      return { lines: [] }
  }
}
